import React from "react";
import { Typography } from "@mui/material";
import { makeStyles } from "@/compat/muiStyles";
import { red } from "@mui/material/colors";

const useStyles = makeStyles((theme) => ({
  asterisk: {
    color: red[600],
  },
  questionText: {
    marginBottom: theme.spacing(1),
  },
}));

const FormQuestionText = ({ text, required }) => {
  const classes = useStyles();

  return (
    <Typography className={classes.questionText}>
      {text} {required && <span className={classes.asterisk}>*</span>}
    </Typography>
  );
};

export default FormQuestionText;
